<template>
  <div class="not-found content-box p-5">
    <span
      class="title-404 font-roboto-mono d-flex font-weight-lighter m-auto text-center mb-5 p-4"
      :class="settings?.title?.class"
      :style="settings?.title?.style"
    >
      {{ settings?.title?.text || 'Loading...' }}
    </span>
    <h1
      class="text-center mt-5"
      :class="settings?.sub_title?.class"
      :style="settings?.sub_title?.style"
    >
      {{ settings?.sub_title?.text || 'Please wait, the page is currently loading.' }}
    </h1>
    <h5
      class="text-center mt-3"
      :class="settings?.description?.class"
      :style="settings?.description?.style"
    >
      {{ settings?.description?.text || '' }}
    </h5>
  </div>
</template>

<script>
export default {
  computed: {
    mode() {
      return this.$route.query.mode;
    },

    settings() {
      return this.$store.state.partners.currentPartner.settings.sections.transition_page?.[this.mode];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/stylesheets/components/not-found.scss';
</style>
